export const StepOneFormMessages = {
  page: {
    title: {
      id: 'signup.Stepone.Page.Title',
      defaultMessage: 'First, we need to confirm your identity',
    },
    instruction: {
      id: 'signup.Stepone.Page.Instruction',
      defaultMessage:
        'We keep your personal health information secure by verifying your identity with the information below.',
    },
  },
  form: {
    dob: {
      label: {
        id: 'signup.StepOne.Form.DateOfBirth.Label',
        defaultMessage: 'Date of birth',
      },
      help: {
        dd: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.DD',
          defaultMessage: 'DD',
        },
        mm: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.MM',
          defaultMessage: 'MM',
        },
        yyyy: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.YYYY',
          defaultMessage: 'YYYY',
        },
        day: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.Day',
          defaultMessage: 'Day accepts numbers only',
        },
        month: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.Month',
          defaultMessage: 'Month accepts numbers only',
        },
        year: {
          id: 'signup.StepOne.Form.DateOfBirth.Help.Year',
          defaultMessage: 'Year accepts numbers only',
        },
      },
    },
    firstname: {
      id: 'signup.Stepone.Form.Firstname',
      defaultMessage: 'First name',
    },
    lastname: {
      id: 'signup.Stepone.Form.Lastname',
      defaultMessage: 'Last name',
    },
    pin: {
      label: {
        id: 'signup.Stepone.Form.Pin.Label',
        defaultMessage: 'PIN',
      },
      help: {
        id: 'signup.Stepone.Form.Pin.Help',
        defaultMessage: 'Provided by your care team.',
      },
    },
    mrn: {
      help: {
        id: 'signup.Stepone.Form.Mrn.Help',
        defaultMessage: 'Your hospital identification number.',
      },
    },
    ssn: {
      label: {
        id: 'signup.Stepone.Form.Ssn.Label',
        defaultMessage: 'SSN',
      },
    },
    button: {
      next: {
        id: 'signup.Stepone.Form.Button.Next',
        defaultMessage: 'Next',
      },
      cancel: {
        id: 'signup.Stepone.Form.Button.Cancel',
        defaultMessage: 'Cancel',
      },
    },
    captcha: {
      label: {
        id: 'signup.Stepone.Form.Captcha.Label',
        defaultMessage: 'Captcha Field',
      },
    },
    error: {
      required: {
        id: 'signup.Stepone.Form.Error.Required',
        defaultMessage: 'Required',
      },
    },
  },
  cancelModal: {
    title: {
      id: 'signup.Stepone.CancelModal.Title',
      defaultMessage: 'Are you sure?',
    },
    message: {
      id: 'signup.Stepone.CancelModal.Message',
      defaultMessage: 'You\'ll lose any changes you\'ve made.',
    },
    submitBtnText: {
      id: 'signup.Stepone.CancelModal.SubmitBtnText',
      defaultMessage: 'Yes, I want to cancel',
    },
    hideBtnText: {
      button: {
        id: 'signup.Stepone.CancelModal.HideBtnText.Button',
        defaultMessage: 'No, take me back',
      },
      description: {
        id: 'signup.Stepone.CancelModal.HideBtnText.Description',
        defaultMessage: 'Closes dialog.',
      },
    },
  },
};
